"use client";
import { isEmptyFilterAtom } from "@/hooks/useCurrentFilters";
import { filterIconAtom } from "@/hooks/headerHooks";
import { useAtom } from "jotai";
import { drawerAtom } from "@/app/components/lib/Drawer";

const SvgFilter = () => {
  const [isNoFilters] = useAtom(isEmptyFilterAtom);

  const [, setShow] = useAtom(drawerAtom);
  const [showFilterIcon] = useAtom(filterIconAtom);
  if (!showFilterIcon) return null;
  return (
    <svg
      onClick={() => setShow(true)}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isNoFilters ? (
        <path
          d="M4.60417 3.25C3.86555 3.25 3.25 3.86555 3.25 4.60417V6.27783C3.25 7.52185 3.82172 8.69854 4.79883 9.46859L10.2917 13.7966V21.9375C10.2917 22.0867 10.3329 22.233 10.4106 22.3604C10.4883 22.4878 10.5996 22.5913 10.7323 22.6596C10.865 22.7279 11.0139 22.7583 11.1627 22.7476C11.3115 22.7368 11.4545 22.6853 11.576 22.5987L15.3677 19.8904C15.473 19.8152 15.5589 19.716 15.6181 19.601C15.6774 19.486 15.7083 19.3585 15.7083 19.2292V13.7956L21.2012 9.46859C22.1783 8.69854 22.75 7.52185 22.75 6.27783V4.60417C22.75 3.86555 22.1344 3.25 21.3958 3.25H4.60417ZM4.875 4.875H21.125V6.27783C21.125 7.02498 20.7833 7.72887 20.1961 8.19165L14.7805 12.4583H11.2195L5.80387 8.19165C5.21665 7.72887 4.875 7.02498 4.875 6.27783V4.875ZM11.9167 14.0833H14.0833V18.8113L11.9167 20.3591V14.0833Z"
          className="fill-dark"
        />
      ) : (
        <path
          d="M10.2917 15.1667V21.9375C10.2917 22.2419 10.4618 22.5209 10.732 22.6601C10.8496 22.7202 10.9769 22.75 11.1042 22.75C11.2705 22.75 11.4362 22.6991 11.5765 22.5989L15.3682 19.8905C15.5816 19.7378 15.7083 19.4913 15.7083 19.2292V15.1667H10.2917ZM21.3958 3.25H4.60417C3.85775 3.25 3.25 3.85775 3.25 4.60417V6.27737C3.25 7.53025 3.81442 8.69321 4.79808 9.46833L9.96829 13.5417H16.0312L21.2014 9.46833C22.1856 8.69321 22.75 7.52971 22.75 6.27737V4.60417C22.75 3.85775 22.1423 3.25 21.3958 3.25Z"
          className="fill-primary"
        />
      )}
    </svg>
  );
};

export default SvgFilter;
